export default __webpack_public_path__ + "static/media/invonboard-image.49278086.jpg";